/**
 * プロダクトCTA（Swiper）
 -----------------------------------*/
const swiper = new Swiper(".product-slider", {
  loop: true,               // ループ有効
  speed: 600,               // スライド速度
  spaceBetween: 10,
  pagination: {
    el: ".product-slider__pagination",
    clickable: true,        // ドットをクリック可能に
  },
  navigation: {
    nextEl: ".product-slider__next",
    prevEl: ".product-slider__prev",
  },
});
